"use client"
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import 'swiper/css';
import "swiper/css/pagination";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Img} from "@/components/Img";
import {Pagination, Navigation, EffectCreative, Autoplay} from "swiper/modules";
import reactHtmlParser from "react-html-parser";
import SliderNavLeft from "@/components/SliderNavLeft";
import SliderNavRight from "@/components/SliderNavRight";
import Title from "@/components/Title";


const MyComponent = ({background, data}) => {
    const [offset, setOffset] = useState()

    useEffect(() => {



        window.addEventListener('load', function () {
            setOffset(document.querySelector(' .container')?.offsetLeft)

        })
        window.addEventListener('resize', function () {
            setOffset(document.querySelector(' .container')?.offsetLeft)

        })
        setOffset(document.querySelector(' .container')?.offsetLeft)
    }, [])

    return (
        <StyledComponent background={background}  className={'amenities pt-100  as-image-text-slider'} id={'award'} offset={offset}>
            <Container>

                <Row>
                    <Col>
                        <Title text={data?.section_data?.subtitle} margin={'0 0 40px 0'}
                        spancolor={'#FFF'}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className={'amenities__big'} lg={{span: 9}}>
                        <div className="amenities__big__slider">


                                <Swiper
                                    modules={[Autoplay, Pagination, Navigation, EffectCreative]}
                                    loop={false}
                                    allowTouchMove={true}
                                    autoplay={false}
                                    initialSlide={0}
                                    pagination={{
                                        // el: '.swiper-pagination',
                                        type: "fraction",
                                    }}
                                    navigation={{
                                        prevEl: '.as-image-text-slider .go-left',
                                        nextEl: '.as-image-text-slider .go-right',
                                    }}
                                    speed={900}
                                >
                                    {
                                        data?.posts?.list && data?.posts?.list?.length > 0 &&
                                        data?.posts?.list?.map((element, i) => {
                                            return (
                                                <SwiperSlide>
                                                        <div className="single__img ">
                                                            <Img src={element?.images?.[0]?.full_path}/>
                                                        </div>
                                                </SwiperSlide>

                                    )
                                       })
                                 }
                                </Swiper>
                            {/*}*/}
                        </div>
                    </Col>
                    <Col className={'amenities__right'} lg={{span: 3}}>
                        <div className="right-slider">
                            <div className="award-slider-nav" style={{"height": "50px","marginBottom":"40px"}} >
                                {
                                    data?.posts?.list?.length > 1 &&
                                    <div className="slider-nav">
                                        <SliderNavLeft/>
                                        <SliderNavRight/>
                                    </div>
                                }

                            </div>

                            {/*{*/}
                            {/*    data?.posts?.list && data?.posts?.list?.length > 0 &&*/}
                            <Swiper
                                modules={[Autoplay, Pagination, Navigation, EffectCreative]}
                                loop={false}
                                allowTouchMove={false}
                                autoplay={false}
                                initialSlide={0}
                                pagination={{
                                    type: "fraction",
                                }}
                                navigation={{
                                    prevEl: '.as-image-text-slider .go-left',
                                    nextEl: '.as-image-text-slider .go-right',
                                }}
                                speed={900}
                                className={'award-content-slider'}
                            >
                                {
                                    data?.posts?.list && data?.posts?.list?.length > 0 &&
                                    data?.posts?.list?.map((element, index) => {
                                        return (
                                            <SwiperSlide>
                                                <h5>{element?.data?.title}</h5>
                                                <p>
                                                    {
                                                        reactHtmlParser(element?.data?.description)
                                                    }
                                                </p>
                                            </SwiperSlide>
                                        )
                                    })
                                }
                            </Swiper>
                        </div>

                        {/*}*/}
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    overflow: hidden;
    background: #7497AC;
    will-change: transform;
    
    @media(max-width: 1024px){
        padding-bottom: 60px;
    }

    .single__img {
        position: relative;
        padding-top: calc(550 / 866 * 100%);
        border-radius: 10px;

        img {
            border-radius: 10px;
        }

        @media (max-width: 767px) {
            padding-top: calc(250 / 345 * 100%);
        }
    }

    .amenities__big {
        position: relative;

        &__slider {
            position: relative;

        }

    }

    .amenities__right {
        //padding-top: 50px;
        position: relative;
        .right-slider{
            width: 100%;
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
            bottom: -0;
            z-index: 9999999;
            @media(min-width: 1700px){
                top: 50%;
            }
            @media(max-width: 1020px){
                position: unset;
                transform: unset;
                .award-content-slider{
                    margin-left: unset;
                }
                .slider-nav{
                    position: absolute;
                    bottom: -120px;
                    justify-content: flex-start;
                }
            }
        }

        .swiper-slide {
            padding: 30px 30px 50px 30px;
            background-color: #3C3C3B;
            border-radius: 10px;
            @media(min-width: 1920px){
                padding: 40px 30px 50px 30px;
            }
        }

        h3 {
            margin-bottom: 30px;
        }

        h5 {
            font-size: 24px;
            line-height: 32px;
            font-weight: 800;
            color: #FFF;
            margin-bottom: 20px;
            @media(min-width: 1920px){
                font-size: 28px;
                line-height: 32px;
            }
            @media(max-width: 768px){
                font-size: 20px;
                line-height: 28px;
            }
        }

        p {
            font-size: 16px;
            line-height: 24px;
            overflow: hidden;
            color: #FFF;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
            white-space: normal;

            @media (max-width: 1024px) {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                white-space: normal;
            }
            @media(min-width: 1920px){
                font-size: 18px;
                line-height: 27px;
            }
        }

    }

    .slider-nav {
        //position: absolute;
        //bottom: 50px;
        //width: 45%;
        //right: 0;
        //top: 15%;
        z-index: 3;
        //padding-left: 20px;
        display: flex;
        justify-content: flex-end;
        //margin-bottom: 40px;
            

        @media(max-width: 767px){
      margin-right: 5px;
    }
  }

  @media (max-width: 950px) {
    .col-sm-5, .col-sm-4 {
      min-width: 100%;
      //padding: 0 30px;
    }

    .amenities__big__thumb {
      width: 45%;
      top: auto;
      bottom: -200px;
    }

    .amenities__right {
      margin-top: -25px;
      margin-bottom: 60px;

      p {
        display: block;
        overflow: visible;
      }
    }
    .award-content-slider{
        margin-left: unset !important;
    }

    .amenities__big__slider .shadow {
      z-index: 1;
      width: 120px;
      right: 0;
      left: calc(23% + 180px);
    }

    .slider-nav {
      width: 95% !important;
        top: unset;
        left: 15px;
    }

  }

 
  
  .swiper-pagination {
    opacity: 0;
    visibility: hidden;
  }
    
    .award-content-slider{
        margin-left: -150px;
    }
    
    .swiper{
        border-radius: 10px;
    }

    @media (max-width: 767px) {
        //margin-top: 100px;
        .amenities__big__thumb {
            height: 150px;
            width: 55%;
            bottom: -75px;
            left: 30px;
            div {
                height: 100%;
                width: 100%;
            }
            .single {
                padding: 0 !important;
            }
        }

        .amenities__big__slider  {
            .shadow-right {
                right: 0;
            }
        }

        .amenities__right {
            margin-top: -30px;
        }

        .award-content-slider{
            margin-left: 0;
        }
        .slider-nav{
            right: unset;
            //bottom: -60px !important;
            top: unset;
        }
    }
    
    @media(max-width: 991px){
        .award-slider-nav{
            height: unset !important;
            margin-bottom: 0 !important;
        }
    }
`;

export default MyComponent;
